export const environment = {
    api_url: process.env.REACT_APP_API_BASE_URL,
    api_header: { 'Content-Type': 'application/json' }
}
